import React from 'react'
import { Route } from 'react-router-dom'
import { ScrollContext } from 'react-router-scroll'
import { ConnectedRouter } from 'react-router-redux'

import { history } from 'store'

import ModalSwitch from './ModalSwitch'

const Router = () => (
  <ConnectedRouter history={history}>
    <ScrollContext>
      <Route component={ModalSwitch} />
    </ScrollContext>
  </ConnectedRouter>
)

export default Router



// WEBPACK FOOTER //
// ./src/Router/index.js